import React from 'react';

function Dashboard() {
    return (
        <div style={{ padding: '20px' }}>
            <h1>🎯 Dashboard</h1>
            <p>Привет! Это страница панели управления.</p>
    </div>
    );
}

export default Dashboard;
